import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../service/global.service';

@Component({
  selector: 'app-sub-branch',
  templateUrl: './sub-branch.component.html',
  styleUrls: ['./sub-branch.component.css']
})
export class SubBranchComponent implements OnInit {

  constructor(private GlobalService: GlobalService) {
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit(): void {
  }

}
